import Customer from '@/Customer/Customer';

export default class PermitCustomer extends Customer {
}
